<template>
    <div  style="overflow: auto; width: 100vw;">
        <v-card flat class="score-trans-white mx-2">
            <v-container fluid >
                <h2>Rebookings</h2>
                <v-data-table 
                    :items="overview" 
                    :headers="getHeaders()" 
                    hide-default-footer 
                    :search="search" 
                    no-data-text="No data to display"
                    loading-text="Loading data...please wait" 
                    :loading="loading"
                    dense>
                    <template v-slot:header.unaccounted>
                        <v-icon medium>mdi-account-question</v-icon>
                    </template>        
                    <template v-slot:item="unit">
                        <tr :class="{'row-background-grey': unit.index%2!==0}">
                            <td :class="{'text-bold-orange': unit.item.description==='Total rebookings open'}">{{ unit.item.description }}</td>
                            <td class="text-bold-only" align="right" :class="{'text-bold-orange': unit.item.description==='Total rebookings open'}">
                                <span v-if="unit.item.total > 0"
                                    :class="{'underscore': !beginsWithClosed(unit.item.description)}" @click="loadSubOverview(unit, null)">
                                    {{ unit.item.total }}
                                </span>
                                <span v-else>-</span>
                            </td>
                            <td class="text-bold-only" align="right" style="color: orangered" :class="{'text-bold-orange': unit.item.description==='Total rebookings open'}">
                                <span v-if="unit.item.unaccounted > 0" class="mr-1" :class="{'underscore': !beginsWithClosed(unit.item.description)}" @click="loadSubOverview(unit, null, true)">
                                    {{ unit.item.unaccounted }}
                                </span>
                            </td>
                            <td v-for="(user, index) in rebookingsAftercare.aftercareUsers" :key="index" 
                                align="right" 
                                :class="{'text-bold-orange': unit.item.description==='Total rebookings open'}">
                                <span v-if="unit.item[user.gebr_code] > 0"
                                      :class="{'underscore': !beginsWithClosed(unit.item.description)}" @click="loadSubOverview(unit, user)">
                                    {{ unit.item[user.gebr_code] }}
                                </span>
                            </td>    
                        </tr>
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
    </div>
</template>
  
<script>
  
    import mxscreensize from '@/components/js/screensize';

    export default {
        components: {
        },        
        mounted() {
            this.getComplaintsOverview()
        },      
        mixins:[mxscreensize],
        created(){
            console.log("window height", this.wInnerHeight);
        },  
        data() {
            return {
                rebookingsAftercare: {},                
                loading: false,
                overview: [],
                search: '',
            }
        },        
        methods: {
            getComplaintsOverview() {
                this.loading = true;
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getRebookingsOverviewAftercare.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getRebookingsOverviewAftercare"
                        },
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                            this.loading = false;
                        } else {                            
                            this.rebookingsAftercare = res.data.getRebookingsOverviewAftercare;
                            this.overview = this.rebookingsAftercare.overview;
                            this.loading = false;
                        }
                    })
            },       
            beginsWithClosed(str) {
                return typeof str === 'string' && str.startsWith('Closed');
            },   
            loadSubOverview(unit, user, unaccounted=false) {

                let entity = 'user'

                // we do not open sub overviews for closed items (numbers too large)
                if (this.beginsWithClosed(unit.item.description)) return
                if(user === null) entity='all'

                let route = this.$router.resolve({ path: `/task/customer_success/homb/homb_overview/${entity}:${user!==null&&user!==undefined ? user.encrid : ''}:${unit.item.filter}:${unaccounted==true?1:0}` }); 
                window.open(route.href, '_blank');

            },            
            getHeaders() {
                const users = this.rebookingsAftercare.aftercareUsers || [];
                // Each user becomes a column`
                // Create an array of objects for the header
                let headers = [];
                headers.push({
                    text: 'Description', // Column label
                    value: 'description', // Unique key for the column
                    width: '14%',
                    sortable: false,
                });
                headers.push({
                    text: '', // Column label
                    value: 'total', // Unique key for the column
                    width: '5%',
                    sortable: false,
                });  
                headers.push({
                    text: '', // Column label
                    value: 'unaccounted', // Unique key for the column
                    width: '5%',
                    sortable: false,
                    align: 'end'
                });                               
                headers = headers.concat(
                    users.map(user => ({
                        text: user.gebr_name, // Column label
                        value: user.gebr_code, // Unique key for the column
                        sortable: false,
                        align: 'end'
                    }))
                );
                return headers;
            }    
        },            
    }  
    
</script>
  
<style scoped>
.score-trans {
    background: transparent !important;
}
.score-trans-white {
    background: rgba(255,255,255,0.5) !important; /* standard card background color */
}
.row-background-grey {
    background: #f5f5f5 !important;
}
.text-bold-orange {
    font-weight: bold !important;
    background-color: #ffedd5 !important;
}
.text-bold-only {
    font-weight: bold !important;
}
.underscore {
    text-decoration: underline !important;
    cursor: pointer !important;
}
</style>